import React from 'react'
import ReactDOM from 'react-dom'
import 'element-theme-default/lib/index.css'
import ReactGA from 'react-ga'
import 'airbnb-browser-shims'
import smoothscroll from 'smoothscroll-polyfill'
import App from './App'

smoothscroll.polyfill()

ReactGA.initialize('UA-124189501-1')

if (window.Raven) {
  window.Raven.config('https://3c689cba17034b4692d7f9173c435ae1@sentry.io/1264945').install()
}

ReactDOM.render(<App />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js